import { z } from 'zod';

import { FormFieldId } from './Content.types';

export const schema = z.object({
    [FormFieldId.contactId]: z.string(),
    [FormFieldId.addressId]: z.string(),
});
